
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import '../Assets/Css/about.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { IoArrowForwardCircleOutline } from "react-icons/io5";

import HariImg from '../Assets/Image/harissolanki.jfif';
import AnandImg from '../Assets/Image/anandSSolanki.jfif';
import ShubhamImg from '../Assets/Image/shubhamSolanki.jpg';
import bhagwan from '../Assets/Image/Bhagwan.png'
import aboutimge from '../Assets/Image/aboutimage.png'
import { FaLeaf, FaFlask, FaRecycle, FaHandsHelping } from 'react-icons/fa'
import { FaSeedling, FaTruckLoading, FaStoreAlt, FaChalkboardTeacher } from 'react-icons/fa'

export default function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const testimonials = [
    {

      role: "Farmer – Maharashtra",
      message:
        "Hiranand Agri Solutions helped me switch to high-yield organic farming. Their team guided me through every step of the way.",
    },
    {

      role: "Agri Dealer – Uttar Pradesh",
      message:
        "From soil testing to product training, their support has helped me grow my agri-input business more confidently.",
    },
    {

      role: "Franchise Owner – Karnataka",
      message:
        "Becoming a Hiranand franchisee has been life-changing. Their branding, logistics, and advisory are world-class.",
    },
    {

      role: "Organic Vegetable Farmer – Madhya Pradesh",
      message:
        "Thanks to their quality seeds and timely training, my vegetable yield has doubled with better prices in local markets.",
    },
    {

      role: "Student, Agri Workshop – Rajasthan",
      message:
        "I attended their training seminar, and it was insightful. Now I feel ready to launch my own sustainable farm.",
    },
    {

      role: "Agri Consultant – Punjab",
      message:
        "The expert insights provided by Hiranand Agri Solutions helped our team implement smarter irrigation and crop planning strategies. Truly professional and impactful.",
    }
  ];

  return (
    <>

      <Helmet>
        <title>About Us | Hiranand Agri Solutions Pvt. Ltd.</title>
        <meta
          name="description"
          content="Learn how Hiranand Agri Solutions Pvt. Ltd. is empowering farmers with innovative, sustainable, and farmer-first agri-tech solutions, training, and franchise support across India."
        />
        <meta
          name="keywords"
          content="About Hiranand Agri, agricultural innovation, sustainable farming, farmer training, agri consulting, R&D, agricultural franchise, rural empowerment"
        />
        <meta name="author" content="Hiranand Agri Solutions Pvt. Ltd." />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="About Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          property="og:description"
          content="Discover how Hiranand Agri Solutions is transforming rural India through science-backed farming, reliable inputs, farmer-first training, and sustainable development."
        />
        <meta property="og:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" /> {/* Replace if needed */}
        <meta property="og:url" content="https://hiranandagrisolutions.com/about" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us | Hiranand Agri Solutions Pvt. Ltd." />
        <meta
          name="twitter:description"
          content="Empowering Indian farmers through R&D, consulting, sustainable inputs, and franchise development — get to know our mission, vision, and core values."
        />
        <meta name="twitter:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />

        <link rel="canonical" href="https://hiranandagrisolutions.com/about" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>


      {/* Banner Section */}
      <div className="banner2-section d-flex align-items-center justify-content-center">
        <div className="banner2-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">Dedication to Innovation and <br /> Service in Agriculture</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Empowering agriculture with smart solutions, sustainability, and community-first innovation.
          </p>

        </div>
      </div>

      {/* About Us Section */}
      <section className="py-5 mb-4" id="about">
        <Container>
          <Row className="align-items-center">
            <Col md={7} data-aos="zoom-in">
              <Row className="text-center section-heading" data-aos="zoom-in" data-aos-delay="200">
                <Col>
                  <h3 className="fw-bold section-title">
                    About <span style={{ color: '#16343E' }}> US</span>
                    <span className="title-decoration"> </span>
                  </h3>
                  <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                    Empowering agriculture through innovation, sustainability, and farmer-first solutions.
                  </p>
                </Col>
              </Row>

              <p className='px-4'>
                <h5 className="mb-3 fw-semibold">
                  Hiranand Agri Solutions Pvt. Ltd. is a committed company that provides a blend of scientific,
                  traditional, and modern technologies to farmers.
                </h5>
                <ul className="about-goals list-unstyled mb-0">
                  <li> Increase agricultural production</li>
                  <li> Enhance farmers' income</li>
                  <li>Promote sustainable development</li>
                </ul>
              </p>
            </Col>

            <Col md={5} data-aos="zoom-in" className="d-flex justify-content-center align-items-center ">
              <img src={aboutimge} alt="About Vinora" className="aboutimg  " />
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-5 founder-director-section bg-light">
        <Container className='text-center'>
          {/* Section Title */}
          <h3 className="fw-bold section-title ">
            Founder & <span style={{ color: '#16343E' }}>Directors</span>
            <span className="title-decoration"></span>
          </h3>

          {/* Content Section */}
          <Row className="gy-5 mt-4 justify-content-center">

            {/* Founder */}
            {/* Founder */}
            <Col md={10} className="person-block text-center">
              <div className=" person-content founder">
              
                <img
                  src={HariImg}
                  alt="Hari Singh Solanki"
                  className="img-fluid rounded-circle mb-3"
                  style={{ width: '180px', height: '180px', objectFit: 'cover', objectPosition: 'top' }}
                />
                 <div>
                   <h5 style={{ color: '#1a1a1a', fontWeight: '600' }}>Founder</h5>
                <h4 className="name">Hari S Solanki</h4>
                <p className="degree"><strong>Degree:</strong> MSc (Ag) Entomology, JNKVV Jabalpur</p>
                <p className='founderinfo'>
                  Founder and Director of <strong>Samrat Seeds</strong>, established in 2002. Honored with the <strong>MP Agriculture Leadership Award (2019)</strong> for excellence in agri-business and building a trusted brand. He leads a skilled team, delivering region-specific, high-quality seeds to Indian farmers.
                </p>
                </div>
              </div>
            </Col>

            {/* Director 1 */}
            <Col md={5} className="person-block">
              <div className="person-content director text-center">
                <img
                  src={AnandImg}
                  alt="Anand Singh Solanki"
                  className="img-fluid rounded-circle mb-3"
                  style={{ width: '180px', height: '180px', objectFit: 'cover', objectPosition: 'top' }}
                />
                <h5 style={{ color: '#1a1a1a', fontWeight: '600' }}>Director (Sales & Marketing)</h5>
                <h4 className="name">Anand S Solanki</h4>
                <p className="degree"><strong>Degree:</strong> BSc Seed Technology (DAVV)</p>
                <p>
                  Anand brings 3 years of field experience in agricultural sales. He expands Samrat Seeds' reach and builds strong relationships with farmers across regions.
                </p>
              </div>
            </Col>

            {/* Director 2 */}
            <Col md={5} className="person-block">
              <div className="person-content director text-center">
                <img
                  src={ShubhamImg}
                  alt="Shubham S Solanki"
                  className="img-fluid rounded-circle mb-3"
                  style={{ width: '180px', height: '180px', objectFit: 'fill', objectPosition: 'top' }}
                />
                <h5 style={{ color: '#1a1a1a', fontWeight: '600' }}>Director (Quality & Research)</h5>
                <h4 className="name">Shubham S Solanki</h4>
                <p className="degree"><strong>Degree:</strong> BSc (Ag), ICAR Affiliated College (Punjab)</p>
                <p>
                  Shubham leads research and quality control, ensuring top seed standards. His agri-background drives innovation and consistency in our products.
                </p>
              </div>
            </Col>


          </Row>
        </Container>
      </section>
      <section className="vision-mission-clean py-5" style={{ backgroundColor: '#F9F9F5' }}>
        <Container>
          <Row className="text-center mb-5" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                Our <span style={{ color: '#16343E' }}>Vision & Mission</span>
                <span className="title-decoration"> </span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                Driving sustainable transformation and empowering farmers through purpose-driven innovation.
              </p>
            </Col>
          </Row>

          <Row className="align-items-stretch justify-content-center gx-5 gy-4">
            {/* Vision */}
            <Col xs={12} md={4} data-aos="fade-up" data-aos-delay="100">
              <div className="vision-box vision-mission-card p-4 text-center shadow-sm rounded d-flex flex-column justify-content-between h-100">
                <h4 className="fw-bold mb-3" style={{ color: '#596B33' }}>Our Vision</h4>
                <p className="flex-grow-1">“To deliver accessible agricultural solutions to every farmer.”</p>
              </div>
            </Col>

            {/* Logo Center */}
            <Col xs={12} md={2} className=" text-center d-flex align-items-center justify-content-center" data-aos="zoom-in" data-aos-delay="150">
              <img
                src={require('../Assets/Image/Hiranand Agri solutions.png')}
                alt="Company Logo"
                className="vision-mission-logo"
              />
            </Col>

            {/* Mission */}
            <Col xs={12} md={4} data-aos="fade-up" data-aos-delay="200">
              <div className="mission-box vision-mission-card p-4 text-center shadow-sm rounded d-flex flex-column justify-content-between h-100">
                <h4 className="fw-bold mb-3" style={{ color: '#6F583A' }}>Our Mission</h4>
                <p className="flex-grow-1">“To empower rural India through R&D-based seeds, training, franchise network, and digital agriculture technologies.”</p>
              </div>
            </Col>
          </Row>

        </Container>
      </section>




      <section className="core-values-section py-5" style={{ backgroundColor: '#F7F1E4' }}>
        <Container>
          <Row className="text-center mb-4" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                Our <span style={{ color: '#16343E' }}>Core Values</span>
                <span className="title-decoration"> </span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 700 }}>
                Our core values reflect our commitment to integrity, sustainability, and innovation in agriculture. These guiding principles drive every decision we make and define the way we support farmers, empower communities, and build a better future for rural India.
              </p>
            </Col>
          </Row>

          <Row className="text-center g-4 justify-content-center" data-aos="fade-up">
            {[
              { title: "Integrity", icon: <FaLeaf size={35} color="#596B33" /> },
              { title: "Innovation", icon: <FaFlask size={35} color="#6F583A" /> },
              { title: "Sustainability", icon: <FaRecycle size={35} color="#16343E" /> },
              { title: "Empowerment", icon: <FaHandsHelping size={35} color="#596B33" /> },
            ].map((value, idx) => (

              <Col xs={6} md={3} key={idx} className="text-center">
                <div className="svg-shield-box">
                  <svg
                    viewBox="0 0 200 250"
                    className="svg-shield"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <path
                      d="M100 5 L195 60 Q200 80 200 130 Q200 200 100 245 Q0 200 0 130 Q0 80 5 60 Z"
                      fill="#bfcaa7"
                      stroke="#16343E"
                      strokeWidth="4"
                    />
                    <foreignObject x="20" y="30" width="160" height="180">
                      <div className="shield-content">
                        {value.icon}
                        <h4 className="fw-semibold mt-2">{value.title}</h4>
                      </div>
                    </foreignObject>
                  </svg>
                </div>
              </Col>

            ))}
          </Row>
        </Container>
      </section>

      <section className="py-4   vinora-background">
        <Container>

          <Row className="p-4 d-flex justify-content-center">
            <Col md={5} data-aos="zoom-in">
              <img
                src={bhagwan}
                alt="Our Team"
                className="img-fluid rounded shadow-sm"
                style={{ width: '100%', height: '350px', objectFit: 'cover', objectPosition: 'top' }}
              />
            </Col>

            <Col md={7} className='text-start' data-aos="zoom-in" >
              <h3 className="fw-bold section-title text-start">
                <span style={{ color: 'white' }}>How do “Hiranand Agri Solutions” go together?</span>

              </h3>
              <p style={{ color: 'white', fontSize: '18px', lineHeight: '1.8' }}>
                At Hiranand Agri Solutions Pvt. Ltd., our consulting isn't just advice — it's a partnership rooted in ground-level experience and scientific knowledge. We help farmers and agri-entrepreneurs make smarter choices through expert guidance on crop planning, resource optimization, and sustainable practices. Our goal is to enable long-term growth, profitability, and resilience for every farmer we work with.
              </p>
              <Button variant="light" className="custom-btn bg-brown " href='/services'
                data-aos="zoom-in" data-aos-delay="300">
                Explore Services <IoArrowForwardCircleOutline size={30} style={{ animation: 'pulse 1.5s infinite', transformOrigin: 'center' }} />
              </Button>
            </Col>
          </Row>
        </Container>
      </section>


      <section className="why-choose-us-section py-5" style={{ backgroundColor: '#F9F9F5' }}>
        <Container>
          <Row className="text-center mb-5" data-aos="fade-down">
            <Col>
              <h3 className="fw-bold section-title">
                Why <span style={{ color: '#16343E' }}>Choose Us</span>
                <span className="title-decoration"> </span>
              </h3>
              <p className="text-muted mx-auto" style={{ maxWidth: 720 }}>
                We blend science, tradition, and sustainability to deliver end-to-end solutions that farmers trust and thrive on.
              </p>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center" data-aos="fade-up">
            {[
              {
                icon: <FaSeedling size={32} color="#596B33" />,
                title: 'Agro-Scientific Approach',
                text: 'We combine traditional knowledge with modern research to improve yield and resilience.'
              },
              {
                icon: <FaTruckLoading size={32} color="#6F583A" />,
                title: 'Reliable Product Supply',
                text: 'Certified seeds, fertilizers, and equipment — always available and delivered promptly.'
              },
              {
                icon: <FaFlask size={32} color="#16343E" />,
                title: 'In-House R&D',
                text: 'Our dedicated research team works on improving seed quality and new innovations.'
              },
              {
                icon: <FaHandsHelping size={32} color="#596B33" />,
                title: 'Farmer-First Guidance',
                text: 'Expert consultation on irrigation, pest control, and agri-strategy.'
              },
              {
                icon: <FaStoreAlt size={32} color="#6F583A" />,
                title: 'Franchise Model',
                text: 'Low investment, high return opportunities with full support and branding.'
              },
              {
                icon: <FaChalkboardTeacher size={32} color="#16343E" />,
                title: 'Training & Seminars',
                text: 'Educating farmers and dealers through regular workshops and events.'
              },
            ].map((item, idx) => (
              <Col xs={12} sm={6} md={4} key={idx}>
                <div className="why-card h-100 text-center p-4 rounded shadow-sm bg-white">
                  <div className="icon mb-3">{item.icon}</div>
                  <h5 className="fw-bold mb-2" style={{ color: '#16343E' }}>{item.title}</h5>
                  <p className="text-muted">{item.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="testimonial-carousel-section my-5">
        <div className="container py-3 ">
          <Row className="align-items-center justify-content-center flex-md-row m-0">
            <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
              Voices of <span style={{ color: '#16343E' }}>Trust & Transformation</span>
              <span className="title-decoration mb-2"></span>
            </h3>
            <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
              Hear how Hiranand Agri Solutions is empowering farmers and entrepreneurs across India.
            </p>
            <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

              <Swiper
                modules={[Autoplay, Pagination]}
                autoplay={{ delay: 4000 }}
                pagination={{ clickable: true }}
                loop
                spaceBetween={30}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 1 },
                  992: { slidesPerView: 1 },
                }}
              >
                {testimonials.map((testimonial, idx) => (
                  <SwiperSlide key={idx}>
                    <div className="testimonial-agri-card">
                      {/* <div className="quote-agri-icon">❝</div> */}
                      <p className="testimonial-agri-text">{testimonial.message}</p>
                      <div className="agri-client-info">
                        <img
                          src={require('../Assets/Image/farmer1.jpg')}
                          alt={testimonial.name}
                          className="agri-avatar"
                        />
                        <div>
                          <div className="agri-name">{testimonial.name}</div>
                          <small className="text-muted">{testimonial.role}</small>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>





            </Col>
          </Row>
        </div>
      </section>






    </>
  );
}
